import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { CloseModal } from '@Actions/modalActions';
import { IAppStateContainer } from '@Reducers/index';

interface IModalRootProps {
  ModalComponent?: React.ComponentType;
  modalProps?: any;
}

export const ModalRoot: React.FC = () => {
  const dispatch = useDispatch();
  const { ModalComponent, modalProps } = useSelector((state: IAppStateContainer) => state.modal);

  if (!ModalComponent) {
    return null;
  }

  const closeModal = () => dispatch(new CloseModal());

  return <ModalComponent {...modalProps} closeModal={closeModal} />;
};
